import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/authHook";

const ProtectedRoutes = () => {
    const { isAuthenticated } = useAuth();
    return isAuthenticated ? <Outlet /> : <Navigate to="/signin" />;
};

export default ProtectedRoutes;